import { render, staticRenderFns } from "./BuyingLists.vue?vue&type=template&id=b4aeaea6&scoped=true"
import script from "./BuyingLists.vue?vue&type=script&lang=ts"
export * from "./BuyingLists.vue?vue&type=script&lang=ts"
import style0 from "./BuyingLists.vue?vue&type=style&index=0&id=b4aeaea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aeaea6",
  null
  
)

export default component.exports